const root = 'conversations';

export const CONVERSATIONS_ROUTE = {
  ROOT: root,
  LATEST: 'latest',
  MY_CONVERSATIONS: 'my-conversations',
  FOLLOWING: 'following',
  MENTIONS: 'mentions',
};
